import db from "astrid-firebase/src/db";
import { useCollectionData } from "astrid-firestore/src/hooks";

export default function useInvoicesByOrderId(orderId) {
	return useCollectionData(
		orderId && db.collection("invoices").where("orderId", "==", orderId).orderBy("created", "desc"),
	);
}
